import type { SVGProps } from 'react';
import * as React from 'react';

const SvgStar16 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.143}
      d="M7.521 2.302c.154-.311.23-.467.335-.516a.33.33 0 0 1 .287 0c.104.05.181.205.335.516l1.458 2.953a.7.7 0 0 0 .1.174q.046.048.105.075c.044.02.094.028.196.043l3.26.477c.344.05.516.075.595.159.07.073.102.173.089.273-.015.114-.14.235-.388.478L11.534 9.23a.7.7 0 0 0-.134.15.3.3 0 0 0-.04.122c-.006.048.003.099.02.2l.557 3.245c.059.342.088.513.033.615a.33.33 0 0 1-.232.169c-.114.02-.268-.06-.575-.222l-2.915-1.533a.7.7 0 0 0-.184-.08.3.3 0 0 0-.128 0 .7.7 0 0 0-.185.08L4.836 13.51c-.307.162-.46.243-.574.222a.33.33 0 0 1-.232-.169c-.056-.102-.026-.273.032-.615l.557-3.245c.017-.101.026-.152.02-.2a.3.3 0 0 0-.04-.122.7.7 0 0 0-.134-.15L2.107 6.934c-.249-.243-.373-.364-.388-.478-.013-.1.019-.2.088-.273.08-.084.251-.109.595-.16l3.26-.476a.7.7 0 0 0 .197-.043.3.3 0 0 0 .103-.075c.034-.036.056-.082.102-.174z"
    />
  </svg>
);
export default SvgStar16;
